export const getDocsLinkQueryParams = (
  month: number,
  year: number,
  company_id: string | undefined,
  filter?: string
) => {
  const queryParams = new URLSearchParams();

  queryParams.set('month', String(month));
  queryParams.set('year', String(year));
  queryParams.set('company_id', company_id || '');
  if (filter) {
    queryParams.set('filter', filter);
  }

  return queryParams.toString();
};
